@if (block) {
  <section class="video-block">
    <lib-video
      [embedVideo]="block.embedVideo"
      [src]="block.mediaVideo | videoPresign | async"
      [poster]="{ uri: block.mediaVideo?.coverImage | preSignedUrl | async }"
      (started)="logUserActivity(activityTypes.USER_START_WATCHING_VIDEO)"
      (watched)="logUserActivity(activityTypes.USER_WATCHED_VIDEO)">
    </lib-video>
  </section>
}
